import RenderManager from "../rendering/render-manager";
import getVWKey from "../helpers/getVWKey";
import * as Events from "../utils/events";
import { goToNextVisibleSlide } from "../slides/add-slide-controls";

const NSString = 'http://www.w3.org/2000/svg'; //DevSkim: ignore DS137138

const svgAttrs = {
  fill:"currentColor", preserveAspectRatio:"xMidYMid meet", height:"1em", width:"1em", viewBox:"0 0 40 40", style:"vertical-align: middle;"
};

const starFilled = "m38.6 14.4q0 0.5-0.5 1.1l-8.1 7.9 1.9 11.2q0 0.1 0 0.4 0 0.5-0.2 0.8t-0.7 0.3q-0.4 0-0.9-0.2l-10-5.3-10 5.3q-0.5 0.2-0.9 0.2-0.5 0-0.7-0.3t-0.3-0.8q0-0.1 0.1-0.4l1.9-11.2-8.1-7.9q-0.6-0.6-0.6-1.1 0-0.8 1.3-1l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9t1.1 0.9l5 10.2 11.2 1.6q1.2 0.2 1.2 1z";
const starEmpty = "m26.9 22.4l6.8-6.6-9.4-1.4-4.2-8.5-4.2 8.5-9.5 1.4 6.9 6.6-1.7 9.4 8.5-4.4 8.4 4.4z m11.7-8q0 0.5-0.5 1.1l-8.1 7.9 1.9 11.2q0 0.1 0 0.4 0 1.1-0.9 1.1-0.4 0-0.9-0.2l-10-5.3-10 5.3q-0.5 0.2-0.9 0.2-0.5 0-0.7-0.3t-0.3-0.8q0-0.1 0.1-0.4l1.9-11.2-8.1-7.9q-0.6-0.6-0.6-1.1 0-0.8 1.3-1l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9t1.1 0.9l5 10.2 11.2 1.6q1.2 0.2 1.2 1z";

class Feedback {

  constructor(options, parentLayer, uuid = THREE.Math.generateUUID()) {
    this.getVWSize = getVWKey;

    /* COMMON 2D ELEMENTS DEFINITION */
    this.uuid = uuid;
    this.isMounted = false;
    this.multiSelectable = false;
    this.type = "2DObject";
    this.type2d = "Feedback";
    this.index = options.index;
    this.parentLayer = parentLayer;

    //dom insertion
    this.domElement = document.createElement('div');
    this.domElement.classList.add("feedback-container");
    this.domElement.innerHTML = "<div>How well did you understand the content?</div>";
    this.domElement.style.position = "absolute";
    this.parentLayer.domElement.appendChild(this.domElement);

    this.dataToSend = {
      rating: 0,
      message: "",
    };

    this.addStars();

    this.addComments();


    this.y = options.y;
    this.x = options.x;
    this.width = options.width || 0.4;
    this.height = options.height || 0.4;

    this.translations = options.translations ? options.translations : {};


    this.sizeSm = options.sizeSm ? options.sizeSm : {
      x: 0.1,
      y: 0.1,
      width: 0.8,
      height: 0.8,
    };

    this.sizeLg = options.sizeLg ? options.sizeLg : {
      x: 0.3,
      y: 0.2,
      width: 0.4,
      height: 0.6,
    };

    if (Q3.editMode) {
      this.domElement.addEventListener('click', e => {
        if (Q3.isSelecting2dObject) return;

        e.stopImmediatePropagation();
        if (Q3.editMode) {
          Q3.multiSelect = {};
          Q3.selected = this;
          Events.fire('selectchange');
          RenderManager.activeCamera.update = true;
        }
      }, false);
    }

    this.redraw = this.redraw.bind(this);

    this.handleListeners(true);

    this.redraw();
  }

  createIcon(d) {
    let svg = document.createElementNS(NSString, 'svg');
    Object.keys(svgAttrs).forEach((key) => {
      let val = svgAttrs[key];
      svg.setAttribute(key, val);
    })
    let g = document.createElementNS(NSString, 'g');
    let path = document.createElementNS(NSString, 'path');
    path.setAttribute("d", d);
    g.appendChild(path)
    svg.appendChild(g);
    return svg;
  }

  addStars() {
    let self = this;
    let starsEl = $(`<div class="stars"></div>`);
    $(this.domElement).append(starsEl);
    this.stars = [];
    for (let i = 1; i <= 5; i++) {
      let starWrap = $(`<label></label>`);
      this.stars.push(starWrap);
      starsEl.append(starWrap.append(this.createIcon(starEmpty), $(this.createIcon(starFilled)).addClass("star-filled")));
      starWrap.on({
        mouseover: function() {
          $(this).addClass('star-over');
          $(this).prevAll().addClass('star-over');
        },
        mouseleave: function() {
          $(this).removeClass('star-over');
          $(this).prevAll().removeClass('star-over');
        },
        click: function() {
          $(this).addClass('star-active');
          $(this).prevAll().addClass('star-active');
          $(this).nextAll().removeClass('star-active');
          self.dataToSend.rating = i;
        }
      });
    }
  }

  addComments() {
    $(this.domElement).append($(`<div>Comments for Embibe?</div>`));
    this.input = $(`<input type="text" class="feedback-input">`);
    $(this.domElement).append(this.input);

    this.input.on("change", (e) => {
      this.dataToSend.message = e.target.value;
    });

    let button = $(`<div class="q3-button feedback-button viewer-button">Submit and Continue</div>`);
    $(this.domElement).append($(`<div class="flex-center"></div>`).append(button));
    button.on("click", () => {
      this.submitFeedback();
    })
  }

  submitFeedback() {
    console.log(this.dataToSend);
    this.stars.forEach((s) => s.removeClass("star-active"));
    this.dataToSend.rating = 0;
    this.input.val("");
    this.dataToSend.message = "";
    !Q3.editMode && goToNextVisibleSlide();
  }

  handleListeners(add) {
    Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
    Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
  }

  setLang(lang) {
    if (!this.translations[lang]) {
      this.translations[lang] = lang;
    }
  }

  setData(data) {
    let currentSize = this.getVWSize();

    Object.assign(this[currentSize], {
      x: data.x,
      y: data.y,
      width: data.width,
      height: data.height
    });

    const object = Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid];

    if (!object[currentSize]) {
      object[currentSize] = {};
    }

    Object.assign(object[currentSize], {
      x: data.x,
      y: data.y,
      width: data.width,
      height: data.height,
    });

    this.redraw();
  }

  getRenderPositionAndSize(width, height) {
    let size = this.getVWSize();
    if (this[size]) {
      Object.assign(this, this[size]);
    }

    if (!width) {
      width = size.width;
    }
    if (!height) {
      height = size.height;
    }

    // if (!Q3.editMode && this.inLetterbox !== false) {
    //   width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
    //   height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
    // }

    let w = this.width * width * RenderManager.pixelRatio;
    let h = this.height * height * RenderManager.pixelRatio;

    if (w < 40) {
      w = 40;
    }
    if (h < 40) {
      h = 40;
    }

    let y, x;
    x = this.x * width * RenderManager.pixelRatio;
    y = this.y * height * RenderManager.pixelRatio;

    return {x, y, w, h};
  }

  redraw(width, height) {
    !width && (width = RenderManager.domElement.width / RenderManager.pixelRatio);
    !height && (height = (RenderManager.domElement.height) / RenderManager.pixelRatio);

    let currentSize = this.getVWSize();

    if (this[currentSize]) {
      Object.assign(this, this[currentSize]);
    }

    const {x, y, w: elWidth, h: elHeight} = this.getRenderPositionAndSize(width, height);

    this.domElement.style.width = elWidth + "px";
    this.domElement.style.height = elHeight + "px";
    this.domElement.style.left = (x || 0) + "px";
    this.domElement.style.top = (y || 0) + "px";

  }

  render(width, height) {
    if (!Q3.data.layers.layers2D[this.parentLayer.uuid] || this.disabled) return;

    if (!this.isMounted || this.target) {
      this.redraw(width, height);

      if (width > 0 && height > 0) {
        this.isMounted = true;
      }
    }
  }

  delete() {
    this.handleListeners(false);


    this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
    this.parentLayer.domElement.removeChild(this.domElement);

    delete this.domElement;

    if (Q3.selected === this) {
      Q3.selected = null;
      Events.fire('selectchange');
    }

  }

}

export default Feedback;
export {Feedback};
